import {WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT} from "tools/webservice";

export const getAssignedCases = (inspectorId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/inspector-case/${inspectorId}/assigned`,
  successCallback,
  mountedRef,
});

export const getAssignedCasesByEmployeeId = (employeeId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint:`/inspector-case/employee/${employeeId}/assigned`,
  successCallback,
  mountedRef,
});

export const getCaseAppointments = (inspectorId, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: payload,
  endpoint: `/inspector-case/${inspectorId}/appointments`,
  successCallback,
  mountedRef,
});

export const postExtensionRequest = (controlIdNumber, dueDate, details, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/inspector-case/cases/${controlIdNumber}/extensions`,
  payload: {
    dueDate,
    details
  },
  successCallback,
  mountedRef,
});

export const canMoveCaseFromWebBackToFrContainer = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/inspector-case/cases/${controlIdNumber}/can-move-to-inspector-container`,
  successCallback,
  mountedRef,
});

export const moveCaseFromWebBackToFrContainer = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/inspector-case/cases/${controlIdNumber}/move-to-inspector-container`,
  successCallback,
  mountedRef,
});
